// extracted by mini-css-extract-plugin
export default {"giftOrPromoRowWrapper":"Qs-z","giftOrPromoSelector":"Rs-z","disabled":"Ss-z","subTitle":"Ts-z","selectShipAddressMessage":"Us-z","changePayment":"Vs-z"};